import { createRecipe } from './runtime.js';

const chatErrorConfig = {"name":"chatError"}

export const chatError = /* @__PURE__ */ createRecipe(chatErrorConfig)